import { render, staticRenderFns } from "./BlackGoldHeader.vue?vue&type=template&id=f51d6972"
import script from "./BlackGoldHeader.vue?vue&type=script&lang=js"
export * from "./BlackGoldHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports